import axios from "@/axios"

const url = "/api/brain/encaste/tareas"

class TareasService {
	async getTasks(params) {
		try {
			const { data } = await axios.get(`${url}`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async storeTask(params) {
		try {
			const { data } = await axios.post(`${url}`, params)
			return data
		} catch (error) {
			return error.response
		}
	}

	async switchActive(id) {
		try {
			const { data } = await axios.put(`${url}/switch-active/${id}`)
			return data
		} catch (error) {
			return error.response
		}
	}
}

export default new TareasService()
